/**
 * Utilities for pagination operations
 */

export const DEFAULT_PAGE_OPTIONS = [5, 10, 15];

export const COLUMN_WIDTHS_2 = ['50%', '50%'];
export const COLUMN_WIDTHS_3 = ['40%', '30%', '30%'];
export const COLUMN_WIDTHS_4 = ['40%', '20%', '20%', '20%'];
export const COLUMN_WIDTHS_5 = ['40%', '15%', '15%', '15%', '15%'];
export const COLUMN_WIDTHS_6 = ['40%', '12%', '12%', '12%', '12%', '12%'];
export const COLUMN_WIDTHS_7 = ['40%', '10%', '10%', '10%', '10%', '10%', '10%'];

export const calculateOffset = (page: number, itemsPerPage: number): number =>
  (page - 1) * itemsPerPage;

export const validatePaginationParams = (page: number, itemsPerPage: number): boolean => 
  page > 0 && itemsPerPage > 0;

export const calculateTotalPages = (totalItems: number, itemsPerPage: number): number =>
  Math.ceil(totalItems / itemsPerPage);